var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0.17041C68.3 0.17041 88 19.8704 88 44.1704C63.7 44.1704 44 24.4704 44 0.17041ZM44 0.17041C19.7 0.17041 0 19.8704 0 44.1704C24.3 44.1704 44 24.4704 44 0.17041ZM0 44.1704C0 68.4704 19.7 88.1704 44 88.1704C44 63.8704 24.3 44.1704 0 44.1704ZM44 88.1704C68.3 88.1704 88 68.4704 88 44.1704C63.7 44.1704 44 63.8704 44 88.1704Z",
    fill: "#62246B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0 0.17041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon08);
export default __webpack_public_path__ + "static/media/icon_08.86b1d38f15a991051ef32f770f5e1fec.svg";
export { ForwardRef as ReactComponent };